import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular/standalone';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';
import { RestService } from './rest.service';
import { SERVER } from './config';
import { HttpClient } from '@angular/common/http';
import { menuController } from '@ionic/core/components';
// import { HelperService } from './helper.service';


@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(
    private alertCtrl: AlertController,
    public storage: StorageService,
    private router: Router,
    private http: HttpClient,
    // private rest: RestService,
    // private helper: HelperService

  ) { }
  public async info(message: string): Promise<any> {
    return new Promise(async resolve => {
        let alert = this.alertCtrl.create({
            header: message,
            buttons: [{
                text: 'OK',
                handler: () => resolve(null)
            }],
            cssClass: ''
        });

        (await alert).present();
    });
  }


public async error(obj: { title: string, error: any, message?: string }) {
    let msg:any = 'Unknown error.';
    if (obj.message) {msg = obj.message;}
    if (typeof obj.error === 'string') {
        msg = obj.error;
    } else if (obj.message && obj.error instanceof Response) {
        if(obj.error) msg = AlertService.getErrorMessage(obj.message, obj.error);
    }

    let alert = this.alertCtrl.create({
        header: obj.title,
        message: msg,
        buttons: [ 'OK' ],
        cssClass: ''
    });

    (await alert).present();
}
  private static async getErrorMessage(message: string, error: Response): Promise<any> {
    if (error instanceof Response) {
        if (error.status === 500) {
            return 'Internal error.';
        }

        let body: any;
        try {
          body = JSON.parse(await error.text());
          console.log("body: ", body)
        } catch (err) {
          console.log("error: ", err)
        }

        switch (message) {
            case 'GET /user':
                switch (body.error) {
                    case 10000: return 'User not found.';
                    case 10001: return 'User not authorized.';
                }
                break;

        }
  }
  }
  public async areUsure(obj: { title: string, message?: string, buttons?:string[], function?:string, param?: any }) {
    let msg:any = 'Unknown error.';
    if(obj.buttons || obj.buttons ===null || obj.buttons === undefined){obj.buttons = ['OK', 'CANCEL'];}

    if (obj.message) {msg = obj.message;}

    let alertButtons = [
      {
        text: obj.buttons[1],
        role: 'cancel',
        handler: () => {
          console.log('Alert canceled');
          this.storage.alertReturn = 'canceled';
        },
      },
      {
        text: obj.buttons[0],
        role: 'confirm',
        handler: () => {
          console.log('Alert confirmed');
          this.storage.alertReturn = 'confirmed';
          if (obj.function) {
            (this as any)[obj.function](obj.param);
          }
          return 'confirmed';
        },
      },
    ];


    let alert = this.alertCtrl.create({
        header: obj.title,
        message: msg,
        buttons: alertButtons,
        cssClass: '',
 
    });

    (await alert).present();
  }
  public async message() {
    let alertButtons = [
      {
        text: this.storage.translation.later_t,
        role: 'cancel',
        handler: () => {
          console.log('Alert canceled');
          this.storage.alertReturn = 'canceled';
          return false;
        },
      },
      {
        text: this.storage.translation.toMessages_t,
        role: 'confirm',
        handler: async () => {
          console.log('Alert confirmed');
          this.storage.alertReturn = 'confirmed';
          this.storage.page = 'message';
          this.router.navigateByUrl('/app/message');
          menuController.close();
        // console.log(this.route.getCurrentNavigation());
        
          return true;
        },
      },
    ];
    let alert = this.alertCtrl.create({
        header: this.storage.translation.newMessages_t, 
        message: this.storage.translation.youHaveNewMessages_t,
        buttons: alertButtons,
        cssClass: ''
    });
    (await alert).present();
  }

  leaveTeam(){
    console.log('leave team');

     const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.put(SERVER + '/team/leave/player',  {headers})
      .subscribe({
      next: (result:any) => {
        console.log(result);
      }
    ,error: (error:any) => {
      console.log(error);
      console.log('error: ', error);
    }
    });
  }
  leaveTeamPlayer(player_id:number){
    console.log('leave team player: ', player_id);

          const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
          this.http.put(SERVER + '/team/player/'+ player_id, {status: 'inactive'}, {headers})
          .subscribe({
          next: (result:any) => {
            console.log(result);
          }
        ,error: (error:any) => {
          console.log('error: ', error);
        }
        });
  //   this.rest.updateTeamPlayer(player_id, {status: 'inactive'}).then((result:any) => { 
  //     console.log('left team player: ', result);
  //     // this.helper.toastMid('Player removed from team: '+ this.storage.selectedTeam.name, 1000);
      let index = this.storage.selectedTeam.players.findIndex((obj:any) => obj.player.id === player_id);
      if(index > -1){
        this.storage.selectedTeam.players.splice(index, 1);
        let index2 = this.storage.teams.findIndex((obj:any) => obj.team.id === this.storage.selectedTeam.team.id);
        if(index2 > -1){
          this.storage.teams[index2] = this.storage.selectedTeam;
        }
      }
      
    
  }
  delTeamCoach(coach_id:number){
    console.log('del team coach: ', coach_id);

          const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
          this.http.delete(SERVER + '/team/coach/'+ coach_id, {headers})
          .subscribe({
          next: (result:any) => {
            console.log(result);
            let index = this.storage.selectedTeam.coaches.findIndex((obj:any) => obj.id === coach_id);
            if(index > -1){
              this.storage.selectedTeam.coaches.splice(index, 1);
            
              let index2 = this.storage.teams.findIndex((obj:any) => obj.team.id === this.storage.selectedTeam.team.id);
              if(index2 > -1){
                this.storage.teams[index2] = this.storage.selectedTeam;
              }
            }
          }
        ,error: (error:any) => {
          console.log('error: ', error);
        }
        });
    
  }

}
